import { apiLink } from '../../../constants/env';
import axiosInstance from '../../AxiosInstance';

const apiLeituraProduto = {
    fecthUltimasLeituras: async (unidadeId, numLeituras) => {
        const URL = `${apiLink()}api/leitura-produto/ultimas-leituras-adicionadas/unidade/${unidadeId}/numero-leituras/${numLeituras}`;
        return await axiosInstance.get(URL)
            .then((res) => res)
            .catch(error => {
                console.error('Erro ao buscar a última leitura do produto');

            })
    },
    upsert: async (leitura) => {
        const URL = `${apiLink()}api/leitura-produto/upsert`;
        return await axiosInstance.put(URL, leitura)
            .then((res) => res)
            .catch(error => {
                console.error('Erro ao fazer o post dos dados:', error);
                throw new Error(error.message);

            })
    }
}

export default apiLeituraProduto;
